export const checkConsecutiveChar = (val: string) => {
  if (/(\w)\1\1\1/.test(val)) {
    return false;
  }

  let ascSeqCharCnt = 0; // 오름차순 연속 문자 카운트
  let descSeqCharCnt = 0; // 내림차순 연속 문자 카운트

  for (let i = 0; i < val.length; i++) {
    // charAt(): 문자값 반환
    const char_0 = val.charAt(i);
    const char_1 = val.charAt(i + 1);
    const char_2 = val.charAt(i + 2);

    // charCodeAt(): 유니코드값 반환
    const diff_0_1 = char_0.charCodeAt(0) - char_1.charCodeAt(0);
    const diff_1_2 = char_1.charCodeAt(0) - char_2.charCodeAt(0);

    if (diff_0_1 === 1 && diff_1_2 === 1) {
      ascSeqCharCnt += 1;
    }

    if (diff_0_1 === -1 && diff_1_2 === -1) {
      descSeqCharCnt += 1;
    }

    if (ascSeqCharCnt > 1 || descSeqCharCnt > 1) {
      return false;
    }
  }

  return true;
};

export const isValidPassword = (val: string) => {
  const password_regex = /(?!.*\s)(?=.{10,30})((?=.*\d)(?=.*[a-zA-Z])(?=.*[{}[\]/?.,;:|)*~`!^\-_+<>@#$%&\\=('"])).*/;
  return password_regex.test(val);
};
